import * as types from 'src/localization/types';

export const create = (data: { total: number }) => (env: types.Env) => ({
  match: env.localizer('components.InstitutionsSearchResult.match', { total: data.total })
});
